import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import ErrorsBlock from "../../../components/errors/ErrorsBlock";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { Device, DeviceModel, SelectOption } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";
import Spinner from "../../../ui/Spinner/Spinner";

const AddAdminDevice = () => {
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/administration/directories/device_models`, true);
  const [modelsList, setModelsList] = useState<SelectOption[]>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    const modelsData = response.data as unknown as DeviceModel[];
    const models = modelsData.map((model) => {
      return { value: model.id, label: model.attributes.name };
    });
    setModelsList(models);
    setLoading(false);
  }, [response]);

  const [devices, setDevices] = useOutletContext<[Device[], Function]>();

  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      device_model: { value: "", label: "" },
      serial_number: "",
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/administration/devices/devices`,
    true
  );

  const onSubmit = (formData: any) => {
    setErrors([]);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          device_model_id: formData.device_model.value,
          serial_number: formData.serial_number,
        },
      },
    });
  };

  const addDevice = (itemSaveResponse: { data: unknown }) => {
    const newUserData = itemSaveResponse.data as unknown as any;
    let sensor_types: any[] = [];
    for (let slot of newUserData.attributes.slots) {
      for (let sensor of slot.sensors) {
        if (!sensor_types.map((type) => type.id).includes(sensor.sensor_type.id)) sensor_types.push(sensor.sensor_type);
      }
    }
    const newData = {
      ...newUserData,
      attributes: {
        ...newUserData.attributes,
        model: newUserData.attributes.model.name,
        slots_count: newUserData.attributes.slots.length,
        sensor_types: sensor_types,
      },
    };
    setDevices([...devices, newData]);
  };

  useEffect(() => {
    if (!saveResponse) return;
    addDevice(saveResponse);
    reset();
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
    console.log(saveError);
  }, [saveError]);

  return loading ? (
    <Spinner />
  ) : (
    <ScrollArea className="w-full">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">{t("adding_device")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            {errors ? <ErrorsBlock errors={errors} /> : ""}
            <Controller
              name="device_model"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("device_model")}*</Label>
                  <SelectButton
                    label={"Выберите модель"}
                    searchable={false}
                    options={modelsList!}
                    value={value ? modelsList?.find((s) => s.value == String(value))! : null}
                    onChange={onChange}
                  />
                </div>
              )}
            />
            <Controller
              name="serial_number"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("serial_number")}*`} />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddAdminDevice;
